import { Form } from 'antd';
import React, { Dispatch, SetStateAction } from 'react';
import { useIntl } from 'react-intl';
import { useForm } from 'antd/es/form/Form';
import { Button } from '../../Button';
import { Modal } from '../Modal';
import { StyledResendModal } from './style';
import { Input } from '../../Input';

interface ResendEmailProps {
  isOpenModal: boolean;
  resendEmail: any;
  cooldown: number;
  pendingEmail: string | null;
  setIsOpenModal: Dispatch<SetStateAction<boolean>>;
}

export const ResendEmail = ({
  isOpenModal,
  setIsOpenModal,
  pendingEmail,
  resendEmail,
  cooldown,
}: ResendEmailProps) => {
  const intl = useIntl();
  const [form] = useForm();

  const handleClose = () => setIsOpenModal(false);

  const handleFinish = async (values: any) => {
    try {
      await form.validateFields();
      resendEmail({ email: values.email });
      setIsOpenModal(false);
    } catch {}
  };

  const footer = cooldown ? (
    `${intl.formatMessage({
      id: 'login.email_already_sent',
    })} (${cooldown}s)`
  ) : (
    <>
      <Button
        label={intl.formatMessage({ id: 'general.resend_email' })}
        htmlType="submit"
        type="primary"
      />
      <Button
        label={intl.formatMessage({ id: 'general.close' })}
        onClick={handleClose}
      />
    </>
  );

  return (
    <Modal
      open={isOpenModal}
      onCancel={handleClose}
      destroyOnClose
      footer={null}
      key="resend-modal"
    >
      <Form form={form} onFinish={handleFinish}>
        <StyledResendModal>
          <div className="title">
            {intl.formatMessage({ id: 'message.verify_email_modal_title' })}
          </div>

          <div className="body">
            <Input
              label={intl.formatMessage({ id: 'general.email' })}
              validations={['required', 'email']}
              name="email"
              initialValue={pendingEmail ?? undefined}
              layout="vertical"
            />
          </div>

          <div className="footer">{footer}</div>
        </StyledResendModal>
      </Form>
    </Modal>
  );
};
